// extracted by mini-css-extract-plugin
export default {"base":"collapsable_base__2P5ZB","body":"collapsable_body__V-OdK","collapsed":"collapsable_collapsed__xJNhF"};